import React, { useState } from 'react';

function formatDate(iso) {
    if (!iso) return null;
    const d = new Date(iso);
    return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

function CredentialsGuide({ guide }) {
    const [open, setOpen] = useState(false);
    if (!guide) return null;

    return (
        <div className='mt-2 mb-3'>
            <button
                type='button'
                className='btn btn-sm btn-outline-info'
                onClick={() => setOpen(o => !o)}
            >
                {open ? '▲' : '▼'} Como obter credenciais da {guide.providerName}?
            </button>

            {open && (
                <div className='card card-body border mt-2 p-3' style={{ fontSize: 14 }}>
                    {guide.intro && <p className='mb-2'>{guide.intro}</p>}

                    <ol className='ps-3 mb-3'>
                        {guide.steps.map((step, i) => (
                            <li key={i} className='mb-2' dangerouslySetInnerHTML={{ __html: step }} />
                        ))}
                    </ol>

                    {guide.warnings && guide.warnings.length > 0 && (
                        <div className='alert alert-warning py-2 mb-2' style={{ fontSize: 13 }}>
                            <strong>Atenção:</strong>
                            <ul className='mb-0 ps-3 mt-1'>
                                {guide.warnings.map((w, i) => <li key={i} dangerouslySetInnerHTML={{ __html: w }} />)}
                            </ul>
                        </div>
                    )}

                    {guide.testnet && (
                        <div className='border-start border-warning border-3 ps-3 mt-3 mb-2'>
                            <strong style={{ fontSize: 13 }}>🧪 Credenciais de Testnet/Demo:</strong>
                            {guide.testnet.intro && (
                                <p className='mb-2 mt-1' style={{ fontSize: 13 }}>{guide.testnet.intro}</p>
                            )}
                            <ol className='ps-3 mb-2' style={{ fontSize: 13 }}>
                                {guide.testnet.steps.map((step, i) => (
                                    <li key={i} className='mb-1' dangerouslySetInnerHTML={{ __html: step }} />
                                ))}
                            </ol>
                            {guide.testnet.note && (
                                <small className='text-muted fst-italic'>{guide.testnet.note}</small>
                            )}
                        </div>
                    )}

                    {guide.futuresTestnet && (
                        <div className='border-start border-primary border-3 ps-3 mt-3 mb-2'>
                            <strong style={{ fontSize: 13 }}>📈 Credenciais de Futuros (testnet):</strong>
                            {guide.futuresTestnet.intro && (
                                <p className='mb-2 mt-1' style={{ fontSize: 13 }}>{guide.futuresTestnet.intro}</p>
                            )}
                            <ol className='ps-3 mb-2' style={{ fontSize: 13 }}>
                                {guide.futuresTestnet.steps.map((step, i) => (
                                    <li key={i} className='mb-1' dangerouslySetInnerHTML={{ __html: step }} />
                                ))}
                            </ol>
                            {guide.futuresTestnet.note && (
                                <small className='text-muted fst-italic'>{guide.futuresTestnet.note}</small>
                            )}
                        </div>
                    )}

                    {guide.subAccount && (
                        <div className='border-start border-info border-3 ps-3 mt-3 mb-2'>
                            <strong style={{ fontSize: 13 }}>🔒 Sub-account (recomendado):</strong>
                            {guide.subAccount.intro && (
                                <p className='mb-2 mt-1' style={{ fontSize: 13 }}>{guide.subAccount.intro}</p>
                            )}
                            <ol className='ps-3 mb-2' style={{ fontSize: 13 }}>
                                {guide.subAccount.steps.map((step, i) => (
                                    <li key={i} className='mb-1' dangerouslySetInnerHTML={{ __html: step }} />
                                ))}
                            </ol>
                            {guide.subAccount.note && (
                                <small className='text-muted fst-italic'>{guide.subAccount.note}</small>
                            )}
                        </div>
                    )}

                    <div className='d-flex justify-content-between align-items-center flex-wrap gap-2'>
                        {guide.docUrl && (
                            <a
                                href={guide.docUrl}
                                target='_blank'
                                rel='noreferrer'
                                className='btn btn-sm btn-outline-primary'
                            >
                                📖 Documentação oficial
                            </a>
                        )}
                        {guide.lastVerified && (
                            <small className='text-muted fst-italic'>
                                Guia atualizado em {formatDate(guide.lastVerified)}.
                                Se algo divergir, consulte a documentação oficial.
                            </small>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default CredentialsGuide;
